module.exports = __webpack_public_path__ + "media/images/favicons/mstile-70x70-e0f76751ce4c77c6511dd03f0ec693ba.png";